import React from 'react';
import Layout from '@/components/layout/Layout';
import { useLanguage } from '@/context/language-context';

const ContentPolicy = () => {
  const { t } = useLanguage();
  const currentDate = new Date();
  const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">{t('content_policy.title')}</h1>
          <p className="text-lg text-muted-foreground mb-6">{t('content_policy.subtitle')}</p>
          <p className="text-sm text-muted-foreground mb-8">{t('content_policy.last_updated')} {formattedDate}</p>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">{t('content_policy.introduction.title')}</h2>
              <p className="text-muted-foreground">{t('content_policy.introduction.content')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">1. Prohibited Content</h2>
              <p className="text-muted-foreground">
                Pink Paradise prohibits content that promotes violence, harassment, discrimination, illegal activities, 
                or explicit material featuring minors. We also prohibit any content that violates the rights of others, 
                including intellectual property rights.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">2. Escort Profile Standards</h2>
              <p className="text-muted-foreground">
                Escort profiles must include accurate information and authentic images. Misrepresentation of services, 
                identity, or qualifications is prohibited. All profiles must clearly state the services offered and 
                adhere to local legal requirements.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">3. Client Behavior Standards</h2>
              <p className="text-muted-foreground">
                Clients must treat escorts with respect and dignity. Harassment, intimidation, or sharing private 
                information without consent is strictly prohibited. Clients who violate these standards may have 
                their accounts suspended or terminated.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">4. Reporting Violations</h2>
              <p className="text-muted-foreground">
                If you encounter content that violates our Content Policy, please report it immediately through the 
                reporting function on our platform. Our moderation team will review all reports and take appropriate action.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContentPolicy;
